import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { closeInCallModal } from 'actions/InCallModal';
import { hooks, signaling } from '@lifesize/clients.sdk';
import { constants as c } from '@lifesize/clients.sdk/dist/signaling';
import TwoButtonModal from 'components/TwoButtonModal';
import classes from './StopPresentationModal.module.scss';

const StopPresentationModal = ({ intl }) => {
  const dispatch = useDispatch();
  const presenter = hooks.usePresentingParticipant() || {};
  const inCallModal = useSelector((state) => get(state, 'app.inCallModal'));

  const messages = defineMessages({
    title: { id: 'components.stopPresentationModal.title', defaultMessage: 'Stop Presentation?' },
    currentPresenter: {
      id: 'components.stopPresentationModal.message',
      defaultMessage: '{name} is currently presenting.'
    },
    endPresentation: {
      id: 'components.stopPresentationModal.endPresentation',
      defaultMessage:
        'Limiting sharing privileges will end their presentation, as they are not a moderator, lecturer, or owner. Is this okay?'
    },
    cancel: { id: 'components.stopPresentation.cancel', defaultMessage: 'Cancel' },
    accept: { id: 'components.stopPresentation.accept', defaultMessage: 'Accept' }
  });

  const onAcceptClicked = () => {
    signaling.modifyRestrictPresentation(c.PresentationRestriction.restrictedShare);
    /*
      to keep track, if current user has initiated the presentation restriction
      and to prevent redundant update in SharingBlock component.
    */
    inCallModal.props.initiatedByCurrentUser = true;
    dispatch(closeInCallModal());
  };

  const getModalBody = () => (
    <>
      <div className={classes.message}>{intl.formatMessage(messages.currentPresenter, { name: presenter.name })}</div>
      <div className={classes.message}>{intl.formatMessage(messages.endPresentation)}</div>
    </>
  );

  return (
    <TwoButtonModal
      title={intl.formatMessage(messages.title)}
      message={getModalBody()}
      primaryButtonText={intl.formatMessage(messages.accept)}
      secondaryButtonText={intl.formatMessage(messages.cancel)}
      onPrimaryButtonClick={() => onAcceptClicked()}
      onSecondaryButtonClick={() => dispatch(closeInCallModal())}
      modalClasses={{
        modal: classes.modal,
        modalContent: classes.modalContent
      }}
    />
  );
};

export default injectIntl(StopPresentationModal);
